<template>
  <div>
    <h1>Attribute Get</h1>

    <KadoMenu />

    <template v-if="idToken">

      <!-- session info area -->
      <div class="div-session">
        <font-awesome-icon icon="user" /> : {{ username }} <span @click="signOut">[ <font-awesome-icon icon="sign-out-alt" title="sign out" /> ]</span>
      </div>
      <hr />

    </template>

    <table class="table-attributeget">
      <tr>
        <td>
          <p>
            <button class="button-normal  button-normal__extra" @click="attributeGet" >Get</button>
          </p>
        </td>
      </tr>
    </table>
    <div class="div-attributeInfo" v-if="attributeInfo" >
      <pre class="pre-attributeInfo" v-html="attributeInfo"></pre>
    </div>
    <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>

  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'AttributeGet',

  components: {
    KadoMenu
  },

  data () {
    return {
      procMsgNormal: null,
      procMsgAttention: null,
      username: '',
      idToken: '',
      attributeInfo: ''
    }
  },

  mounted: function () {
    this.checkSession()
  },

  methods: {

    /* =================================================================================
     * signOut
     *   サインアウト
     * ============================================================================== */
    signOut () {
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: Start', mc.LOG_TYPE_I) : (() => { })()
      const myAuth = new MyAuth()
      myAuth.signOut()
      this.username = ''
      this.idToken = ''
      this.$router.push('/auth/signin')
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
          setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * attributeGet
     *   属性情報を取得
     * ============================================================================== */
    async attributeGet () {
      mc.LOG_LEVEL ? console.log('%c info: Method=attributeGet: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      // 認証セッションの状態をチェック
      await this.checkSession()
      if (!this.idToken) { return false }
      const myAuth = new MyAuth()
      await myAuth.attributeGet(this.username)
        .then(result => {
          mc.LOG_LEVEL ? console.log('%c info: Method=attributeGet: OK', mc.LOG_TYPE_I) : (() => { })()
          this.attributeInfo = JSON.stringify(result, null, '\t').replace(/\t/g, ' ')
        })
        .catch(err => {
          mc.LOG_LEVEL ? console.log('%c error: call=myAuth.attributeGet: err:', mc.LOG_TYPE_E, err) : (() => {})()
          this.WriteProcMsg('attention', JSON.stringify(err))
        })
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  }
}
</script>

<style scoped>
.div-session {
  text-align: right;
}
.div-session .fa-sign-out-alt {
  cursor: pointer;
}
.table-attributeget {
  margin-left: auto;
  margin-right: auto;
}
.button-normal__extra {
  width: 10em;
}
.div-attributeInfo {
  padding: 1em;
  width: min-content;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  border: 1px solid #ccc;
  outline: none;
  background-color: #fafafa;
}
.pre-attributeInfo {
  margin: 0;
  padding: 0;
  display: block;
  width: min-content;
  text-align: left;
}
</style>
